module.exports = __webpack_public_path__ + "static/slack-guid-1-1746aa2fb67e7b411d841dee179de836.png";